import 'url-search-params-polyfill';
import Vue from 'vue';
import VueMasonry from 'vue-masonry-css';
import vueSmoothScroll from 'vue-smoothscroll';
import bookingUrl from './helpers/bookingUrl';

jQuery(document).ready(function () {
  if (!jQuery('.price-list').length) {
    return;
  }

  window.priceListCommonData = {
    areasAndTreatments: false,
    activeArea: false,
    selectableTreatments: [],
    selectedTreatment: false,
    selectingArea: true,
    selectingTreatment: false,
    priceSearchResults: [],
    priceSearchQuery: '',
    minimumQueryLength: 3,
    selectedCity: null,
    availableCities: [],
    cityDropdownOpen: false,
    showPlaceholderCityLabel: false,

    ui: {
      loading: {
        prices: true,
      },
      modalState: 0,
    },
  };

  window.priceListCommonMethods = {
    doPriceSearch() {
      this.priceSearchResults = [];
      var results = [];
      var resultsSlugs = []; // Keep track of the slugs of the treatments we display as search results so that we don't display the same treatment several times.

      let searchQuery = this.priceSearchQuery.toLowerCase();

      /* Only do the search if the query is longer than x characters */
      if (searchQuery.length >= this.minimumQueryLength) {
        for (let i in this.areasAndTreatments) {
          var area = this.areasAndTreatments[i];
          if (area.treatments && area.treatments.length) {
            for (var x in area.treatments) {
              var treatment = area.treatments[x];
              var treatmentName = treatment.name.toLowerCase();
              if (treatmentName.includes(searchQuery)) {
                if (!resultsSlugs.includes(treatment.slug)) {
                  treatment.area = area;
                  results.push(treatment);
                  //resultsSlugs.push(treatment.slug);
                }
              }
            }
          }
        }
      } else {
        results = [];
      }
      this.priceSearchResults = results;
    },
    clearPriceSearchQuery() {
      this.priceSearchQuery = '';
      this.priceSearchResults = [];
    },
    handleSelectSearchResult(result) {
      this.setActiveArea(result.area);
      this.setActiveTreatment(result);
      this.$SmoothScroll(
        document.getElementById('price-areas-and-treatments-list-anchor'),
        500
      );
    },
    setModalState: function (value) {
      /* Set the modal state. If the value is 0, the modal should not be shown and we'll remove the body class. If it is above 1, we'll add the body class */

      if (value > 0) {
        this.addBodyClass();
        this.ui.modalState = value;
      } else {
        this.removeBodyClass();
        this.ui.modalState = 0;
      }
    },

    /* Toggle a body element class when modal is opened/closed to prevent weird modal background scrolling on mobile Safari */
    toggleBodyClass: function () {
      var body = document.getElementsByTagName('BODY')[0];
      body.classList.toggle('mobile-menu-toggled');
    },

    removeBodyClass: function () {
      var body = document.getElementsByTagName('BODY')[0];
      body.classList.remove('mobile-menu-toggled');
    },

    addBodyClass: function () {
      var body = document.getElementsByTagName('BODY')[0];
      body.classList.add('mobile-menu-toggled');
    },

    setupPriceListByPriceId(priceSlug) {
      for (var i in this.areasAndTreatments) {
        var area = this.areasAndTreatments[i];
        for (var x in this.areasAndTreatments[i].treatments) {
          var treatment = this.areasAndTreatments[i].treatments[x];
          if (treatment.slug == priceSlug) {
            this.setActiveArea(area);
            this.setActiveTreatment(treatment);
            return;
          }
        }
      }
    },

    setupPriceList() {
      if (window.profetPreload && window.profetPreload.pricedata) {
        this.ui.loading.prices = false;
        this.areasAndTreatments = window.profetPreload.pricedata;
        /* Order treatment areas */
        this.areasAndTreatments = _.sortBy(
          this.areasAndTreatments,
          (o) => o.order
        );
        /* Order treatment types */
        for (var i in this.areasAndTreatments) {
          this.areasAndTreatments[i].treatments = _.sortBy(
            this.areasAndTreatments[i].treatments,
            (o) => parseInt(o.order, 10)
          );
        }
        this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) =>
          parseInt(o.order, 10)
        );

        // Populate available cities from contact info when available, otherwise derive from prices
        const preloadedCities = this.getCitiesFromContactInfo();
        if (preloadedCities && preloadedCities.length) {
          this.availableCities = preloadedCities;
        } else {
          this.availableCities = this.getAllAvailableCities();
        }
        this.setStockholmAsDefault();
        // Try to hydrate from REST endpoint if only Stockholm exists
        this.maybeHydrateCitiesFromEndpoint();

        /* Check if there's a query parameter set for the price id */
        var uri = window.location.search.substring(1);
        var params = new URLSearchParams(uri);
        if (params.get('behandling')) {
          /* Call method to set up the price list so that the 'correct' price gets displayed by default */
          this.setupPriceListByPriceId(params.get('behandling'));
        }
      } else {
        axios.get('/wp-json/nk/getTreatmentPrices/').then((response) => {
          this.ui.loading.prices = false;
          this.areasAndTreatments = response.data.data;
          /* Order treatment areas */
          this.areasAndTreatments = _.sortBy(
            this.areasAndTreatments,
            (o) => o.order
          );
          /* Order treatment types */
          for (var i in this.areasAndTreatments) {
            this.areasAndTreatments[i].treatments = _.sortBy(
              this.areasAndTreatments[i].treatments,
              (o) => parseInt(o.order, 10)
            );
          }
          this.areasAndTreatments = _.sortBy(this.areasAndTreatments, (o) =>
            parseInt(o.order, 10)
          );

          // Populate available cities from contact info when available, otherwise derive from prices
          const preloadedCities = this.getCitiesFromContactInfo();
          if (preloadedCities && preloadedCities.length) {
            this.availableCities = preloadedCities;
          } else {
            this.availableCities = this.getAllAvailableCities();
          }
          this.setStockholmAsDefault();
          // Try to hydrate from REST endpoint if only Stockholm exists
          this.maybeHydrateCitiesFromEndpoint();
        });
      }
    },

    setActiveArea(area) {
      this.activeArea = area;
      this.selectableTreatments = [];
      this.selectingArea = false;
      this.selectingTreatment = true;
      area.expanded = true;

      for (var treatment in this.activeArea.treatments) {
        var singleTreatment = this.activeArea.treatments[treatment];
        this.selectableTreatments.push(singleTreatment);
      }

      /* Order all treatments */
      this.selectableTreatments = _.sortBy(this.selectableTreatments, (o) =>
        parseInt(o.order, 10)
      );
    },

    setActiveTreatment(treatment) {
      this.selectingTreatment = false;
      this.selectedTreatment = treatment;
      this.activeArea.expanded = true;
      this.updateURL('?behandling=' + treatment.slug);
    },

    resetFilters() {
      this.updateURL('');
      this.activeArea = false;
      this.selectableTreatments = [];
      this.selectingArea = true;
      this.selectingTreatment = false;
      this.selectedTreatment = false;

      for (var i in this.areasAndTreatments) {
        this.areasAndTreatments[i].expanded = false;
      }
    },

    closeModal() {
      this.ui.modalState = 0;
    },

    generateBookingLink(treatment) {
      return bookingUrl(treatment.activity_id);
    },

    /* Insert query parameter in url */
    /* https://eureka.ykyuen.info/2015/04/08/javascript-add-query-parameter-to-current-url-without-reload/ */
    updateURL(queryStringToAdd) {
      if (history.pushState) {
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          queryStringToAdd;
        window.history.pushState({ path: newurl }, '', newurl);
      }
    },

    // City-related methods
    setSelectedCity(city) {
      this.selectedCity = city;
      this.cityDropdownOpen = false;
      this.filterTreatmentsByCity();
    },

    toggleCityDropdown() {
      this.cityDropdownOpen = !this.cityDropdownOpen;
      this.showPlaceholderCityLabel = false;
    },

    selectCity(city) {
      this.setSelectedCity(city);
      this.showPlaceholderCityLabel = false;
    },

    handleClickOutside(event) {
      const dropdown = document.querySelector('.custom-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.cityDropdownOpen = false;
      }
    },

    clearCityFilter() {
      this.selectedCity = null;
      this.cityDropdownOpen = false;
      this.filterTreatmentsByCity();
    },

    filterTreatmentsByCity() {
      // This method will be called whenever city selection changes
      // The computed property will automatically update the filtered data
      // Force update to ensure UI reflects the changes
      this.$forceUpdate();
    },

    getPriceForCity(treatment, cityId = null) {
      const targetCity = this.selectedCity || null;
      const targetCityId = cityId || (targetCity ? targetCity.id : null);
      const targetCitySlug = targetCity ? targetCity.slug : null;

      // Check for city-specific pricing first
      if (treatment.pricing && (targetCityId || targetCitySlug)) {
        let cityPrice = null;
        if (targetCityId) {
          cityPrice = treatment.pricing.find((p) => p.city_id == targetCityId);
        }
        if (!cityPrice && targetCitySlug) {
          cityPrice = treatment.pricing.find(
            (p) => p.city_slug == targetCitySlug
          );
        }
        if (cityPrice) {
          return {
            price: cityPrice.price,
            price_from: cityPrice.price_from,
            formatted_text: null, // Will be formatted by formatPrice
          };
        }
      }

      // If Stockholm is selected and no city-specific pricing exists,
      // show the default price (Stockholm fallback)
      if (
        targetCity &&
        targetCity.name &&
        targetCity.name.toLowerCase() === 'stockholm'
      ) {
        return {
          price: null,
          price_from: false,
          formatted_text:
            treatment.default_price_text || treatment.short_information,
        };
      }

      // For other cities, if no city-specific pricing exists, don't show price
      return {
        price: null,
        price_from: false,
        formatted_text: 'Kontakta oss för pris',
      };
    },

    formatPrice(priceData) {
      // If we have formatted text (existing price from short_information), use it as-is
      // This preserves any HTML formatting that might be in the original data
      if (priceData.formatted_text) {
        return priceData.formatted_text;
      }

      // If we have a numeric price (city-specific), format it
      if (priceData.price) {
        const formattedPrice = new Intl.NumberFormat('sv-SE').format(
          priceData.price
        );
        const prefix = priceData.price_from ? 'Från ' : '';
        return `${prefix}${formattedPrice} kr`;
      }

      return '';
    },

    getAllAvailableCities() {
      // Add safety check for when data hasn't loaded yet
      if (!this.areasAndTreatments) {
        return [];
      }

      const cities = new Map();

      // Always include Stockholm as the default/fallback city
      cities.set('stockholm', {
        id: 'stockholm',
        name: 'Stockholm',
        slug: 'stockholm',
      });

      for (let areaKey in this.areasAndTreatments) {
        const area = this.areasAndTreatments[areaKey];
        if (area.treatments) {
          for (let treatmentKey in area.treatments) {
            const treatment = area.treatments[treatmentKey];
            if (treatment.treatments) {
              for (let singleTreatment of treatment.treatments) {
                if (singleTreatment.cities) {
                  for (let city of singleTreatment.cities) {
                    cities.set(city.id, city);
                  }
                }
              }
            }
          }
        }
      }

      return Array.from(cities.values()).sort((a, b) => {
        // Put Stockholm first, then sort alphabetically
        if (a.name.toLowerCase() === 'stockholm') return -1;
        if (b.name.toLowerCase() === 'stockholm') return 1;
        return a.name.localeCompare(b.name);
      });
    },

    getCitiesFromContactInfo() {
      try {
        const preloaded =
          typeof window !== 'undefined' &&
          window.profetWPVars &&
          Array.isArray(window.profetWPVars.contactInformation)
            ? window.profetWPVars.contactInformation
            : null;
        if (!preloaded) {
          return [];
        }

        const mapped = preloaded
          .filter((c) => c && (c.id || c.slug) && c.name)
          .map((c) => ({
            id: c.id || c.slug,
            name: c.name,
            slug: c.slug || c.id,
          }));

        return mapped.sort((a, b) => {
          if ((a.name || '').toLowerCase() === 'stockholm') return -1;
          if ((b.name || '').toLowerCase() === 'stockholm') return 1;
          return (a.name || '').localeCompare(b.name || '');
        });
      } catch (e) {
        return [];
      }
    },

    maybeHydrateCitiesFromEndpoint() {
      try {
        // If we already have more than one city, skip
        if (this.availableCities && this.availableCities.length > 1) {
          return;
        }

        if (typeof axios === 'undefined') {
          return;
        }

        axios
          .get('/wp-json/nk/getContactInformation/')
          .then((res) => {
            const data = res && res.data && res.data.data ? res.data.data : [];
            if (!Array.isArray(data) || data.length <= 1) {
              return;
            }

            const mapped = data
              .filter((c) => c && (c.id || c.slug) && c.name)
              .map((c) => ({
                id: c.id || c.slug,
                name: c.name,
                slug: c.slug || c.id,
              }));

            if (mapped.length > 1) {
              // Merge with any existing cities (prefer endpoint values)
              const bySlug = new Map();
              for (let c of this.availableCities || []) {
                bySlug.set((c.slug || c.id || '').toString(), c);
              }
              for (let c of mapped) {
                bySlug.set((c.slug || c.id || '').toString(), c);
              }

              this.availableCities = Array.from(bySlug.values()).sort(
                (a, b) => {
                  if ((a.name || '').toLowerCase() === 'stockholm') return -1;
                  if ((b.name || '').toLowerCase() === 'stockholm') return 1;
                  return (a.name || '').localeCompare(b.name || '');
                }
              );

              // Ensure Stockholm is selected by default if nothing is selected
              if (!this.selectedCity) {
                this.setStockholmAsDefault();
              }
            }
          })
          .catch(() => {});
      } catch (e) {}
    },

    setStockholmAsDefault() {
      // Find Stockholm in the available cities and set it as default
      const stockholm = this.availableCities.find(
        (city) => city.name.toLowerCase() === 'stockholm'
      );
      if (stockholm) {
        this.selectedCity = stockholm;
        this.filterTreatmentsByCity();
      }
    },

    getFilteredAreasAndTreatments() {
      // If no city is selected, return empty object to hide all treatments
      if (!this.selectedCity || !this.areasAndTreatments) {
        return {};
      }

      const filtered = {};

      for (let areaKey in this.areasAndTreatments) {
        const area = this.areasAndTreatments[areaKey];
        const filteredTreatments = {};
        let hasVisibleTreatments = false;

        if (area.treatments) {
          for (let treatmentKey in area.treatments) {
            const treatment = area.treatments[treatmentKey];
            const availableTreatments = [];

            if (treatment.treatments) {
              for (let singleTreatment of treatment.treatments) {
                if (this.isTreatmentAvailableInCity(singleTreatment)) {
                  availableTreatments.push(singleTreatment);
                }
              }
            }

            if (availableTreatments.length > 0) {
              filteredTreatments[treatmentKey] = {
                ...treatment,
                treatments: availableTreatments,
              };
              hasVisibleTreatments = true;
            }
          }
        }

        if (hasVisibleTreatments) {
          // Use the original area object to preserve reactivity
          filtered[areaKey] = area;
          // Update treatments with filtered version
          filtered[areaKey].treatments = filteredTreatments;
        }
      }

      return filtered;
    },

    isTreatmentAvailableInCity(treatment, cityId = null) {
      const targetCity = this.selectedCity || null;
      const targetCityId = cityId || (targetCity ? targetCity.id : null);
      const targetCitySlug = targetCity ? targetCity.slug : null;

      if (!targetCityId) {
        return true; // Show all treatments if no city is selected
      }

      // If treatment has city data, check if it's available in the selected city
      if (treatment.cities && treatment.cities.length > 0) {
        return treatment.cities.some(
          (city) =>
            city.id == targetCityId ||
            (targetCitySlug && city.slug == targetCitySlug)
        );
      }

      // If treatment has no city data, only show it when Stockholm is selected (fallback)
      // Assuming Stockholm has ID 1 or name "Stockholm" - we'll check by name to be safe
      if (
        this.selectedCity &&
        this.selectedCity.name.toLowerCase() === 'stockholm'
      ) {
        return true;
      }

      return false;
    },

    shouldShowDefaultPrice(treatment) {
      // Don't show default price (short_information) if we have city-specific pricing for the selected city
      const targetCityId = this.selectedCity ? this.selectedCity.id : null;

      if (targetCityId && treatment.pricing) {
        const hasCityPrice = treatment.pricing.some(
          (p) => p.city_id == targetCityId
        );
        return !hasCityPrice; // Hide default if we have city-specific price
      }

      return true; // Show default price when no city is selected or no city-specific pricing
    },

    getVisibleTreatmentsCount(area) {
      if (!area.treatments) {
        return 0;
      }

      let count = 0;
      for (let treatmentKey in area.treatments) {
        const treatment = area.treatments[treatmentKey];
        if (treatment.treatments) {
          for (let singleTreatment of treatment.treatments) {
            if (this.isTreatmentAvailableInCity(singleTreatment)) {
              count++;
            }
          }
        }
      }
      return count;
    },
  };

  Vue.use(VueMasonry);
  Vue.use(vueSmoothScroll);

  new Vue({
    el: '.price-list',

    data: window.priceListCommonData,

    methods: window.priceListCommonMethods,

    created() {
      this.setupPriceList();
    },

    mounted() {
      // Close dropdown when clicking outside
      document.addEventListener('click', this.handleClickOutside);
    },

    beforeDestroy() {
      // Clean up event listener
      document.removeEventListener('click', this.handleClickOutside);
    },

    computed: {
      filteredAreasAndTreatments() {
        return this.getFilteredAreasAndTreatments();
      },
    },
  });
});
